import { IAuthContext } from 'interfaces/utils.interface'
import React from 'react'

export const authContext = React.createContext<IAuthContext | undefined>(undefined)
